// src/nav/config.js

import SvgColor from '../../../components/svg-color';
const environment = process.env.NODE_ENV;

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;
const SHOW_PRODUCTS_NAV = false;

const defaultNavConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
    active: true,
  },
  // {
  //   title: 'Profile',
  //   path: '/dashboard/user',
  //   icon: icon('ic_profile'),
  // },
  {
    title: 'Logistics',
    path: '/dashboard/logistics',
    icon: icon('ic_shopping'),
    active: true,
  },
  // {
  //   type: 'separator',
  // },
  {
    title: 'Reports',
    path: '/dashboard/reports',
    icon: icon('ic_article'),
    active: true,
  },
  {
    title: 'Settings',
    path: '/dashboard/settings',
    icon: icon('ic_settings_alt'),
    active: true,
  },
  {
    title: 'Cards',
    path: '/dashboard/cards',
    icon: icon('ic_analytics'),
  },
]
.filter((item) => environment === 'development'? item : item.active)

const depotExecutiveNavConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
    active: true,
  },
  {
    title: 'Logistics',
    path: '/dashboard/logistics-tab',
    icon: icon('ic_logistics'),
    active: true,
  },
  {
    title: 'Financials',
    path: '/dashboard/financial-tab',
    icon: icon('ic_finance'),
    active: true,
  },
  ...(SHOW_PRODUCTS_NAV
    ? [
        {
          title: 'Products',
          path: '/dashboard/products',
          icon: icon('ic_article'),
          active: true,
        },
      ]
    : []),
  {
    title: 'Settings',
    path: '/dashboard/settings',
    icon: icon('ic_settings_alt'),
    active: true,
  },
].filter((item) => environment === 'development' ? item : item.active);

export const getNavConfig = (userInfo = {}) => {
  const roles = userInfo?.realm_access?.roles || [];
  const isDepotExecutive = roles.includes('DEPOT-EXECUTIVE-C1');

  if (isDepotExecutive) {
    return depotExecutiveNavConfig;
  }

  return defaultNavConfig;
};

export default defaultNavConfig;


